import { call, takeLatest } from 'redux-saga/effects';
import * as api from '@api/qcTasks';
import { QCTasksListFetchAction } from './QCTasksList.types';
import { actions } from './QCTasksList.slice';
import { Resp, dispatch } from '../helpers';

export function* QCTasksListFetchWorker({
  payload: { clinicalTrialId, filters },
}: QCTasksListFetchAction) {
  try {
    const response: Resp<typeof api.fetchQCTasks> = yield call(
      api.fetchQCTasks,
      clinicalTrialId,
      filters
    );
    yield dispatch(actions.fetchQCTasksListSuccess(response.data));
  } catch (e) {
    yield dispatch(actions.fetchQCTasksListError(e as Error));
  }
}

export function* QCTasksListSaga() {
  yield takeLatest(actions.fetchQCTasksList.type, QCTasksListFetchWorker);
}
